module.exports = __webpack_public_path__ + "img/pin-stroke.d8ea4272.svg";